module.exports = __webpack_public_path__ + "static/media/background.94cb36c1.jpg";